import React, { useEffect, useState } from 'react';
import { Product } from '@inter-ikea-storageone/range';
import theme from 'ui/theme';
import styled from 'styled-components';
import { useAvailability } from 'contexts/availability';
import { useServiceSettings } from 'contexts/serviceSettings';

const Dot = styled.span`
  width: 0.25rem;
  height: 0.25rem;
  display: block;
  min-width: 0.5rem;
  min-height: 0.5rem;
  border-radius: 4rem;
  flex-shrink: 0;
  position: relative;
  transform: scale(0.9);
  margin-right: 0.5rem;
  border-style: solid;
  margin-top: 0.3rem;
`;

const HomeDeliveryAvailability = styled.span`
  display: flex;
`;

type Props = {
  product: Product;
  zipCode: string;
  bigIcon?: boolean;
  shortText?: boolean;
};

const GetHomeDeliveryStockIndicator = ({ product, zipCode, bigIcon, shortText }: Props) => {
  const [homeDelivery, setHomeDelivery] = useState<undefined | boolean>(undefined);
  const { translations } = useServiceSettings();
  const { zipAvailabilities, getProductHomeDelivery } = useAvailability();

  useEffect(() => {
    const status = getProductHomeDelivery(product);
    setHomeDelivery(status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipAvailabilities]);

  const homeDelivieryStatusAvailableWithZipCode =
    translations.kompis.homeDeliveryStatusAvailable &&
    translations.kompis.homeDeliveryStatusAvailable.replace(`{{zip_code}}`, zipCode);

  const homeDeliveryStatusUnavailableWithZipCode =
    translations.kompis.homeDeliveryStatusUnavailable &&
    translations.kompis.homeDeliveryStatusUnavailable.replace(`{{zip_code}}`, zipCode);

  switch (homeDelivery) {
    case true: {
      return (
        <HomeDeliveryAvailability data-testid="home-delivery-availability-true">
          <Dot
            style={{
              backgroundColor: theme.colors.semantic.positive,
              borderColor: theme.colors.semantic.positive,
              borderWidth: bigIcon ? '0.125rem' : 0,
              height: bigIcon ? '0.75rem' : '0.25rem',
              width: bigIcon ? '0.75rem' : '0.25rem'
            }}
          />
          <span>
            {shortText
              ? translations.kompis.zipAvailabilityAvailable
              : homeDelivieryStatusAvailableWithZipCode}
          </span>
        </HomeDeliveryAvailability>
      );
    }
    case false: {
      return (
        <HomeDeliveryAvailability data-testid="home-delivery-availability-false">
          <Dot
            style={{
              backgroundColor: bigIcon ? theme.colors.transparent : theme.colors.semantic.negative,
              borderColor: bigIcon ? theme.colors.semantic.negative : theme.colors.transparent,
              borderWidth: bigIcon ? '0.125rem' : 0,
              height: bigIcon ? '0.8rem' : '0.25rem',
              width: bigIcon ? '0.8rem' : '0.25rem'
            }}
          />
          <span>
            {shortText
              ? translations.kompis.zipAvailabilityUnavailable
              : homeDeliveryStatusUnavailableWithZipCode}
          </span>
        </HomeDeliveryAvailability>
      );
    }
    default: {
      return <></>;
    }
  }
};

export default GetHomeDeliveryStockIndicator;
